module.exports = __webpack_public_path__ + "img/oficina.aa1082ea.svg";